import styled from "styled-components";

export const SelectStyled = styled.select`
  display: flex;
  width: 100%;
  margin-bottom: 1.2rem;
  padding: 20px 30px;
  z-index: 1;
  position: relative;
  color: #99a3ba;
  border-width: 1px;
  border-color: ${props => 
    props.requiredField === 'error' 
    ? "#e63946" 
    : "#999999"};
  border-style: solid;
  background: #fff;
  border-radius: 20px;
  transition: border 0.3s ease;
  line-height: 25px;
  color: #08223e;
  font-size: 20px;
  font-weight: 400;
  font-family: "Red Hat Display", Sans-serif;
  outline: none;
  :focus-within {
    background-color: rgba(233, 245, 252, 1);
  }
  &::placeholder {
    color: #08223e;
    font-family: "Red Hat Display", Sans-serif;
  }
`;

export const TextStyled = styled.p`
  width: 800px;
`;

export const LinkStyled = styled.a`
  color: #1f81c7;
  text-decoration: underline;
`;
